export const AUTH_KEYS = {
  ACCESS_TOKEN: 'jwt',
  REFRESH_TOKEN: 'refresh',
};
